if(typeof require !== 'undefined'){
  const EventSentenceFilter = require('./filters/event-sentence.js');
}

angular.module('admin')

  .filter('allToDashes', function(){
    return function(str){
      return str.replace(/[^0-9A-Z]/ig, '-');
    }
  })

  .filter('estimateCorrect', function(){
    return function(str){
      switch (str) {
        case 'close':
          return 'close';
        case 'toolow':
          return 'too low';
        case 'toohigh':
          return 'too high';
        default:
          return '';
      }
    }
  })

  .filter('mapsSlug', function(){
    return function(address){
      var unitHashed = address.unit ? '#' + address.unit : '';
      var str = address.street + ' ' + unitHashed + ' ' + address.zip;
      return _.kebabCase(str);
    }
  })
  .filter('homeUpdateSentence', function(){
    return function(answers){
      if(typeof answers.homeUpdated === 'undefined')
        return '';
      if(answers.homeUpdated === 'false') // This is a string in DB
        return 'The home has not been updated since they bought it.';
      if(answers.homeUpdated && answers.homeUpdatedScale)
        return 'The home has been improved with ' + answers.homeUpdatedScale + ' updates.';

      return 'The home has been updated.';
    }
  })
  .filter('additionalUpdates', function(){
    return function(unParseableUpdatesString) {
      const noUpdateMsg = 'The home has not been updated'
      try {
        if(unParseableUpdatesString == null) return noUpdateMsg

        const parseable = `{${unParseableUpdatesString}}`
        const updates = JSON.parse(parseable)
        const completed = Object.keys(updates)
              .reduce((acc, camelCaseUpdateName) => {
                const updated = updates[camelCaseUpdateName]
                const humanizedUpdateName = _.snakeCase(camelCaseUpdateName).replace('_', ' ')

                return updated ? acc.concat(humanizedUpdateName) : acc
              }, [])
              .join(', ')

        return completed ? `List of updates: ${completed}` : noUpdateMsg
      } catch (error) {
        Rollbar.error('had trouble parsing the list of additional updates', {error, unParseableUpdatesString})
        return noUpdateMsg
      }
    }
  })
  .filter('appreciation', ['$filter', function($filter) {
    return function(diff) {
      return diff > 0 ? `worth ${$filter('money')(diff)} more than` :
        diff < 0 ? `worth ${$filter('money')(Math.abs(diff))} less than` :
        'equal to'
    }
  }])

  .filter('eventSentence', ['$filter', function($filter){
    return EventSentenceFilter($filter);
  }])

  .filter('clientNames', ['HelperService', function(helpers){
    return function(home){
      let names = helpers.clientNameDisplay(home.users);
      return names || 'No users attached yet';
    }
  }])

  .filter('clientNamesForwards', function(){
    return function(home){
      var users = _.cloneDeep(home.users);

      if(!users || !users.length) return 'No users attached yet';

      if(users.length === 1)
        return `${users[0].first_name} ${users[0].last_name}`;

      if(users[0].last_name === users[1].last_name)
        return `${users[0].first_name} & ${users[1].first_name} ${users[0].last_name}`;
      else
        return `${users[0].first_name} ${users[0].last_name} & ${users[1].first_name} ${users[1].last_name}`;
    }
  })

  .filter('clientFirstNames', function(){
    return function(home){
      if(!home.users || !home.users.length) return 'No users attached yet';

      if(home.users.length === 1)
        return home.users[0].first_name;
      else
        return home.users[0].first_name + ' & ' + home.users[1].first_name;
    }
  })

  .filter('userEmailIssue', function(){
    return function(user){
      if(user.emailVerificationCode === 'spam')
        return 'Marked as spam';

      if(user.emailVerificationCode === 'soft_bounce' || user.emailVerificationCode === 'hard_bounce')
        return 'Email bounced';

      if(user.emailValid === false)
        return 'Invalid email';

      if(user.digestEmailUnsubscribed)
        return 'Unsubscribed';

      return user.emailVerificationCode;
    }
  })

  .filter('abbreviatedMoney', function(){
    return function(number){
      return Helpers.abbreviateMoney(number);
    }
  })

  .filter('ratePercent', function(){
    return function(number){
      return (Math.round(number * 1000) / 1000) + '%';
    }
  });
